// tb_user.group_id that is limited to policy check + sale/commission report.
// The API (app/Filters/AuthFilter.php) enforces the same rule on backend/* endpoints.
export const LIMITED_GROUP = 4

// pages a limited backend user may open
export const LIMITED_PATHS = [
  '/policy/expiry', '/policy/search', '/policy/card',
  '/report/ezl', '/report/ezg', '/report/pa',
  '/report/ezlcom', '/report/ezgcom', '/report/pacom',
]
